module.exports = __webpack_public_path__ + "img/home_side_bar_sdg.1b688d60.png";